<script>
import Input from "@/pages/components/form/horizontal/input.vue";
import MultipleRadios from "@/pages/components/form/horizontal/multiple-radios.vue";

export default {
  components: {MultipleRadios, Input},
  inheritAttrs: false,
  emits: ['update:modelValue'],
  props: {
    'modelValue': {
      required: true,
    },
    'name': {
      required: true,
      type: String,
    },
    'label': {
      required: true,
      type: String,
    },
    'required': {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<template>
  <Input
      v-bind="$attrs"
      :name="name"
      :label="label"
      :model-value="modelValue"
      :required="required"
      type="number"
      @update:modelValue="this.$emit('update:modelValue', $event)"
  />
</template>